<template>
	<app-header-teleport>
		<div class="flex flex-1 items-center">
			<app-title :title="`Discount ${discount?.title}`" />
		</div>
	</app-header-teleport>
	<div v-if="discount" class="flex gap-2">
		<div class="w-full flex flex-1 flex-col mt-5">
			<app-section class="flex flex-col">
				<app-title title="Discount Details" class="small" />
				<app-line />
				<div class="flex justify-between items-center mb-1">
					<div class="flex flex-col">
						<span>{{ discount.title }}</span>
						<span>{{ discount.description }}</span>
					</div>
					<span
						>-{{
							discount.percentage
								? discount.discount + '%'
								: $filters.formatCurrency(discount.discount, currency?.code)
						}}</span
					>
				</div>
				<div class="flex justify-between items-center">
					<span class="font-bold">Start Time</span>
					{{ $filters.formatDate(discount.startDate) }}
				</div>
				<div class="flex justify-between items-center">
					<span class="font-bold">End Time</span>
					{{ $filters.formatDate(discount.endDate) }}
				</div>
				<div class="flex justify-between items-center">
					<span class="font-bold">Coupon Code</span>
					{{ discount.couponCode }}
				</div>
				<div class="flex justify-between items-center">
					<span class="font-bold">Minimum Order</span>
					{{ $filters.formatCurrency(discount.minimumOrder, currency.code) }}
				</div>
			</app-section>
			<restaurant-details class="card-details" :restaurant="discount.restaurant" />
		</div>
		<div class="mt-5 w-full card-details flex flex-1 flex-col ">
			<app-section>
				<app-button class="btn btn-success transparent" @click="showOrdersTable = !showOrdersTable">
					{{ showOrdersTable ? 'Hide Orders with this discount' : 'Show Orders with this discount' }}
				</app-button>
				<app-line />
				<discount-orders v-if="showOrdersTable" :discountId="discountId" :businessIDs="businessIDs" />
			</app-section>
		</div>
	</div>
</template>

<script>
	import AppTitle from '@/components/app/AppTitle';
	import AppHeaderTeleport from '@/components/app/AppHeaderTeleport';
	import AppButton from '@/components/app/AppButton';
	import DiscountOrders from '@/components/discount/DiscountOrders';
	import AppLine from '@/components/app/AppLine';
	import DiscountService from '@/services/DiscountService';
	import { mapGetters } from 'vuex';
	import UtilityService from '@/services/UtilityService';
	import RestaurantDetails from '@/components/orders/details/RestaurantDetails';

	export default {
		name: 'DiscountDetails',
		components: {
			RestaurantDetails,
			AppLine,
			DiscountOrders,
			AppButton,
			AppHeaderTeleport,
			AppTitle,
		},
		computed: {
			...mapGetters({
				user: 'user',
			}),
			businessIDs() {
				return this.user.restaurants.map((business) => business.restaurantID);
			},
		},
		data: () => ({
			showOrdersTable: false,
			discount: null,
			discountId: null,
			currency: { code: 'ALL' },
		}),
		methods: {
			getDiscountData() {
				DiscountService.getDiscountById(this.discountId)
					.then((data) => {
						this.discount = data;
						this.currency = data.city.country.currency;
					})
					.catch((e) => {
						this.$notificationService.error(e);
					})
					.finally(() => this.emitter.emit('isLoading', false));
			},
		},
		mounted() {
			this.discountId = UtilityService.decrypt(this.$route.params.id);
			this.getDiscountData();
		},
	};
</script>

<style scoped></style>
